import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import { pro } from "./config";
firebase.initializeApp({ ...pro });
